(() => {
  angular
    .module('app.settings')
    .controller('IntegratedCampaignsSettingsController', IntegratedCampaignsSettings);


  IntegratedCampaignsSettings.$inject = [
    '$q',
    '$scope',
    'ModalService',
    'IntegratedCampaignsService',
  ];

  function IntegratedCampaignsSettings(
    $q,
    $scope,
    ModalService,
    IntegratedCampaignsService,
  ) {
    const vm = this;
    vm.providers = [];

    const SEARCH_KEY = `IntegratedReports${$('#current-user').data('companyId')}Search`;
    vm.search = localStorage.getItem(SEARCH_KEY) || '';

    $scope.$watch(() => vm.search,
      search => {
        if (!search) {
          localStorage.removeItem(SEARCH_KEY);
        } else {
          localStorage.setItem(SEARCH_KEY, search);
        }
      }, true);

    const providersMap = {
      dv360: "Google Display & Video 360 partners",
      adwords: "Google Ads accounts",
      facebook: "Facebook Ad accounts",
    };

    const getStatus = (account, provider) => {
      const map = {
        facebook: {
          awaitingrequest: {
            value: 'awaitingrequest',
            title: 'Awaiting AudienceProject to send Linkage Request',
            content: 'We will send account linkage request shortly',
          },
          awaitingrequestapproval: {
            value: 'awaitingrequestapproval',
            title: 'Awaiting you to approve connection',
            content: 'Please open Facebook Business Manager and approve the request for access from AudienceProject',
          },
          rejected: {
            value: 'rejected',
            title: 'Rejected',
            content: 'FIXME',
          },
          revoked: {
            value: 'revoked',
            title: 'Revoked',
            content: 'Your account is revoked',
          },
          indexing: {
            value: 'indexing',
            title: 'BUG',
            content: 'BUG',
          },
          connected: {
            value: 'connected',
            title: 'Connected',
            content: 'Your account is connected and can be used in Integrated Reports',
          },
        },
        dv360: {
          awaitingrequestapproval: {
            value: 'awaitingrequestapproval',
            title: 'Awaiting AudienceProject Approval',
            content: `We’re currently reviewing your request to link ${account.accountId} with this AudienceReport account`
          },
          rejected: {
            value: 'rejected',
            title: 'Declined by AudienceProject',
            content: `We have declined your request to link ${account.accountId} with this AudienceReport account`,
          },
          revoked: {
            value: 'revoked',
            title: 'Revoked',
            content: 'Your account is revoked',
          },
          indexing: {
            value: 'indexing',
            title: 'Indexing',
            content: 'We are currently indexing your Display & Video 360 account, so campaigns are not yet available',
          },
          connected: {
            value: 'connected',
            title: 'Connected',
            content: 'Your account is connected and can be used in Integrated Reports',
          },
        },
        adwords: {
          awaitingrequest: {
            value: 'awaitingrequest',
            title: 'Awaiting AudienceProject to send Linkage Request',
            content: 'We will send account linkage request shortly',
          },
          awaitingrequestapproval: {
            value: 'awaitingrequestapproval',
            title: 'Awaiting you to approve connection',
            content: 'Please approve the link request sent to your Google Ads account',
          },
          rejected: {
            value: 'rejected',
            title: 'Declined by AudienceProject',
            content: `We have declined your request to link ${account.accountId} with this AudienceReport account`,
          },
          revoked: {
            value: 'revoked',
            title: 'Revoked',
            content: 'Your account is revoked',
          },
          indexing: {
            value: 'indexing',
            title: 'Indexing',
            content: 'We are currently indexing your Google Ads account, so campaigns are not yet available',
          },
          connected: {
            value: 'connected',
            title: 'Connected',
            content: 'Your account is connected and can be used in Integrated Reports',
          },
        },
      };

      return map[provider][account.status.toLowerCase()];
    };

    const getIntegratedCampaigns = () => {
      vm.loading = true;
      IntegratedCampaignsService.get().$promise
        .then(data => {
          var providers = Object.keys(data.data)
            .filter(provider => data.data[provider].length > 0)
            .map(provider => ({
                provider,
                providerName: providersMap[provider],
                accounts: data.data[provider].map(account => ({
                  ...account,
                  status: getStatus(account, provider),
                  checked: false,
                })),
            }));
        vm.loading = false;
        vm.providers = providers;
      });
    };

    vm.openManageIntegratedCampaignsModal = () => {
      ModalService
        .showModal({
          templateUrl: `../../assets/js/app/settings/modals/integratedcampaigns.manage.html?v=${window.BUILD_VERSION}`,
          controller: 'IntegratedCampaignsModalController',
          controllerAs: 'manageModal',
          inputs: {
            providers: vm.providers,
          }
        })
        .then(modal => {
          modal.element.modal();
          modal.close.then(isSuccess => {
            if (isSuccess) {
              vm.loading = true;
              getIntegratedCampaigns();
            }
          });
        });
    };

    vm.openDeleteModal = (provider, account) => {
      ModalService
        .showModal({
          templateUrl: `../../assets/js/app/settings/modals/integratedcampaigns.delete.html?v=${window.BUILD_VERSION}`,
          controller: 'IntegratedCampaignsDeleteModalController',
          controllerAs: 'deleteModal',
          inputs: {
            provider,
            account,
            accounts: vm.selectedAccounts,
          }
        })
        .then(modal => {
          modal.element.modal();
          modal.close.then(confirmDelete => {
            if (confirmDelete) {
              vm.loading = true;
              const idToken = localStorage.getItem('idToken');

              if (provider) {
                IntegratedCampaignsService.delete({
                  requestId: account.requestId,
                  idToken,
                }).$promise
                  .then(() => getIntegratedCampaigns());
              } else {
                const promises = vm.selectedAccounts
                  .map(({ requestId }) => IntegratedCampaignsService.delete({
                    requestId,
                    idToken,
                  }));

                $q.all(promises.map(promise => promise.$promise))
                  .then(() => getIntegratedCampaigns());
              }
            }
          });
        });
    };

    vm.getAccounts = provider => vm.providers.find(i => i.provider === provider).accounts,

    vm.getAllAccounts = () => vm.providers.reduce((memo, provider) => {
      memo.push(...provider.accounts);
      return memo;
    }, []);

    /* vm.getAllSelected = () => vm.getAllAccounts
      .filter(i => i.checked)
      .map(i => ({
        requestId: i.requestId,
        accountId: i.accountId
      })); */

    vm.selectedAccounts = [];
    vm.checkAccount = ({ provider }, account) => {
      account.checked = !account.checked;

      if (account.checked) {
        vm.selectedAccounts.push({
          ...account,
          provider,
        });
      } else {
        vm.selectedAccounts = vm.selectedAccounts.filter(item => item.accountId !== account.accountId);
      }
    };

    vm.toggleAll = provider => {
      vm.getAccounts(provider).forEach(account => {
        vm.checkAccount(provider, account);
      });
    };

    vm.isAllChecked = provider => _.every(
      vm.getAccounts(provider),
      account => account.checked,
    );

    vm.isAnyChecked = () => _.some(vm.getAllAccounts(), account => account.checked);

    getIntegratedCampaigns();
  }
})();
